import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: "sps-workflow-document-status, sps-wf-ds",
    templateUrl: "./sps-workflow-document-status.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsWorkflowDocumentStatusComponent {
    static readonly displayName = "sps-workflow-document-status, sps-wf-ds";
    static readonly props = {
        icon: "string",
    };

    @HostBinding("class.sps-workflow__document-status") readonly _spsWorkflowDocumentStatusClass = true;

    @Input() icon: string;
}
